import { gql } from "@apollo/client"
import {
  SCHEDULE_LIST_FRAG,
  TRANSPORT_DETAIL_FRAG,
} from "./scheduling.fragments.gql"
// Queries
export const SCHEDULE_LIST = gql`
  query ScheduleList(
    $date: Date!
    $filter: ScheduleFilterInput
    $query: String
    $first: Int
    $skip: Int
  ) {
    schedulesForDate(
      date: $date
      filter: $filter
      query: $query
      first: $first
      skip: $skip
    ) {
      ...ScheduleListFrag
    }
  }
  ${SCHEDULE_LIST_FRAG}
`

export const SCHEDULES_FOR_PLOT = gql`
  query PlotSchedules($plotId: Int!) {
    schedulesForPlot(plotId: $plotId) {
      id
      date
      gatePass
      labourCount
      requiredQuantity
      transportServiceProvider {
        id
        fullName
      }
      aggregator {
        id
        fullName
      }
      plot {
        id
        name
        address {
          id
          village
        }
      }
      variety {
        id
        name
        commodity {
          id
          name
        }
      }
      vehicle {
        id
        registrationNumber
      }
    }
  }
`
export const SCHEDULE_TRANSPORT_DETAIL = gql`
  query ScheduleTransportDetail($schedule: Int!) {
    transportDetail(schedule: $schedule) {
      ...TransportDetailFrag
    }
  }
  ${TRANSPORT_DETAIL_FRAG}
`

export const HARVESTERS = gql`
  query AllAgregatorsSelector(
    $department: ID
    $date: Date!
    $first: Int
    $skip: Int
    $query: String
  ) {
    usersByGroup(
      groupName: "Aggregator"
      departmentId: $department
      status: "AV"
      first: $first
      skip: $skip
      query: $query
    ) {
      id
      number
      fullName
      schedulesForDate(date: $date) {
        id
        plotCommodity {
          id
          name
        }
      }
    }
  }
`

export const TRANSPORT_SERVICE_PROVIDER = gql`
  query AllTransportServiceProvidersSelector(
    $department: ID
    $date: Date!
    $first: Int
    $skip: Int
    $query: String
  ) {
    usersByGroup(
      groupName: "Transport Service Provider"
      departmentId: $department
      status: "AV"
      first: $first
      skip: $skip
      query: $query
    ) {
      id
      number
      fullName
      schedulesForDate(date: $date) {
        id
        plotCommodity {
          id
          name
        }
      }
    }
  }
`

export const SCHEDULE_LIST_SUMMARY = gql`
  query ScheduleListSummary(
    $date: Date!
    $query: String
    $filter: ScheduleFilterInput
    $first: Int
    $skip: Int
  ) {
    schedulesForDateSummary(
      date: $date
      query: $query
      filter: $filter
      first: $first
      skip: $skip
    ) {
      plots
      labours
      count
      vehicles
      totalSkuCount
      totalUomQuantity
      aggregators
      transportServiceProviders
    }
  }
`
export const SCHEDULING_VEHICLES = gql`
  query ShedulingVehicles(
    $date: Date!
    $first: Int
    $skip: Int
    $query: String
  ) {
    allVehicles(first: $first, skip: $skip, query: $query) {
      id
      registrationNumber
      vehicleType {
        id
        category
        name
        capacity
        capacityUnit {
          id
          name
          codename
        }
      }
      schedulesForDate(date: $date) {
        id
        plotCommodity {
          id
          name
        }
      }
    }
  }
`
export const PRE_TRIP_GENERATE = gql`
  query PreTripGenerate($date: Date, $scheduleIds: [ID]) {
    preTripGenerate(date: $date, scheduleIds: $scheduleIds) {
      vehicleNo
      bookingCount
      suppliers {
        name
        village
        crop
        sku
        skuCount
      }
    }
  }
`

export const PACKAGING_MATERIAL_DETAIL = gql`
  query PackagingMaterialQuery($id: Int!) {
    packagingMaterial(id: $id) {
      id
      createdAt
      schedule {
        gatePass
        booking {
          id
          status
        }
        vehicle {
          id
          registrationNumber
        }
        gradePrices {
          id
          price
        }
      }
      fieldSupervisorName {
        id
        firstName
        lastName
        fullName
      }
      pmSupervisorName {
        id
        firstName
        lastName
        fullName
      }
      areaInchargeName {
        id
        firstName
        lastName
        fullName
      }
      plotVisitorName {
        id
        firstName
        lastName
        fullName
      }
      supplierType
      packagingMaterialItems {
        id
        skuType {
          id
          name
          selfWeight
          capacity
        }
        dispatchedBoxCount
        harvestedBoxCount
        receivedQuantity
        mismatchBoxCount
        recievedTareWt
        harvestedGrossWt
        harvestedNetWt
        remark
      }
      combinedPackagingMaterialItems {
        skuType {
          id
          name
          selfWeight
        }
        whatsappApproval
        dispatchedBoxCount
        dispatchedBoxWt
        harvestedBoxCount
        harvestedBoxWt
        remark
        fourHand
        fiveHand
        sixHand
        sevenEightHand
        cluster
      }
      finalWt
      leafWt
      fruitNetWt
      totalReceivedTareWt
      weightSlip
      wasteageWt
      totalDispatchedBoxWt
      fruitWt
      fruitAmt
      wastageAmt
      stickAmt
      deductionAmt
      fruitAndWastageWt
      stickWtPercent
      stickWt
      totalHarvestWt
      deductionWt
      deductionWtPercent
      totalHarvestQuantity
      totalHarvestedBoxWt
      totalQuantity
      totalReceivedQuantity
      netWeightAfterDeduction
      remark
      totalAmt
      avgRate
      finalAmt
      attachments {
        id
        mediaType
        url
      }
    }
  }
`
